export enum ConversationType {
	NORMAL = 'NORMAL',
}
